export function isNullOrUndefined(item: any){
    return item === null || item === undefined;
}